import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { requestClubsOffers } from '../../../../util/api';
import { IconSpinner } from '../../../../components';
import { useIsMobile } from '../../../../hooks/useIsMobile';
import { useRequest } from '../../../../hooks/useRequest';
import { countryMapper, getUserCountry } from '../../../../util/location';
import OfferBlock from './OfferBlock';
import css from './SectionOurPartners.css';
import { useSelector } from 'react-redux';
import CountriesTab from '../../common/CountriesTab';

const SectionOurPartners = ({ handleAdminAction, header = null }) => {
    const currentUser = useSelector(state => state.user.currentUser);
    const [country, setCountry] = useState(null);
    const [offersData, setOffersData] = useState([]);
    const [showAll, setShowAll] = useState(false);
    const [isMobile, , computing] = useIsMobile(1024);

    const { error, loading, request } = useRequest();

    const filterByCountry = ({ countries }) =>
        !country || countries.includes(countryMapper[country]);

    const currentUserId = currentUser && currentUser.id ? currentUser.id.uuid : null;
    const showAdminSet = typeof handleAdminAction === 'function';
    const offers = offersData.filter(filterByCountry);
    const offersAvailable = showAll ? offers : offers.slice(0, 4);
    const noDataAvailable = !offersAvailable.length;

    useEffect(() => {
        if (showAdminSet) setShowAll(true);
    }, [showAdminSet]);

    useEffect(() => {
        if (!Array.isArray(offers)) return;
        setShowAll(offers.length <= 4);
    }, [country]);

    useEffect(() => {
        const initialCountry = countryMapper[getUserCountry()];
        setCountry(initialCountry);

        request(requestClubsOffers, data => (Array.isArray(data) ? setOffersData(data) : null));
    }, [currentUserId]);

    if (computing) return <IconSpinner />;
    if (loading) return <IconSpinner />;
    if (error) return <p className={css.error}>Failed to fetch data: {error}</p>;

    return (
        <section className={css.root}>
            {header}

            <CountriesTab country={country} setCountry={setCountry} />

            <main className={css.offersHolder}>
                {offersAvailable.map((offer, index) => (
                    <OfferBlock
                        key={index}
                        {...offer}
                        threeLinesHeight={isMobile ? 60 : 84}
                        handleAdminAction={
                            showAdminSet ? action => handleAdminAction(action, offer) : null
                        }
                    />
                ))}
                {noDataAvailable && (
                    <p>Für dieses Land gibt es derzeit noch keine Partnerschaften.</p>
                )}
            </main>

            {!showAll && !noDataAvailable && (
                <footer className={css.footer}>
                    <button
                        type="button"
                        className={css.subLinkOutlined}
                        onClick={() => setShowAll(true)}
                    >
                        Alle anzeigen
                    </button>
                </footer>
            )}
        </section>
    );
};

export default SectionOurPartners;
